var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "cb-training" } }, [
    _c(
      "div",
      { staticClass: "d-flex", staticStyle: { "background-color": "#ffffff" } },
      [
        _c("div", { staticClass: "content" }, [
          _c(
            "div",
            { staticClass: "filters" },
            [
              !!_vm.filters.period
                ? _c("MiniFilterPreview", {
                    attrs: {
                      type: "period",
                      "on-removed": function () {
                        return (_vm.filters.period = undefined)
                      },
                      label: _vm.getFilterLabel("period"),
                    },
                    model: {
                      value: _vm.filters.period,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "period", $$v)
                      },
                      expression: "filters.period",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              !!_vm.filters.storyId
                ? _c("MiniFilterPreview", {
                    attrs: {
                      type: "story",
                      "on-removed": function () {
                        return (_vm.filters.storyId = undefined)
                      },
                      label: _vm.getFilterLabel("story"),
                    },
                    model: {
                      value: _vm.filters.storyId,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "storyId", $$v)
                      },
                      expression: "filters.storyId",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              !!_vm.filters.ignored
                ? _c("MiniFilterPreview", {
                    attrs: {
                      type: "ignore",
                      "on-removed": function () {
                        return (_vm.filters.ignored = undefined)
                      },
                      label: _vm.getFilterLabel("ignore"),
                    },
                    model: {
                      value: _vm.filters.ignored,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "ignored", $$v)
                      },
                      expression: "filters.ignored",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              !!_vm.filters.query
                ? _c("MiniFilterPreview", {
                    attrs: {
                      type: "query",
                      "on-removed": function () {
                        return (_vm.filters.query = undefined)
                      },
                      label: _vm.getFilterLabel("query"),
                    },
                    model: {
                      value: _vm.filters.query,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "query", $$v)
                      },
                      expression: "filters.query",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "wrapper" },
            [
              _c(
                "div",
                { staticClass: "cb-train-query-list-pagination" },
                [
                  _c("Pagination", {
                    attrs: {
                      "page-change": _vm.pageChange,
                      "page-sizes": _vm.pagination.pageSizes,
                      total: _vm.total,
                      pageSizeLocalStorageKey: "cb-train-page-size",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("QueryList", {
                staticClass: "cb-trian-query-list",
                attrs: {
                  "selected-items": _vm.selectedItems,
                  "on-select-changed": _vm.onSelectChanged,
                  rows: _vm.rows,
                  "select-all": _vm.selectAll,
                  "unselect-all": _vm.unselectAll,
                  "delete-single-row": _vm.deleteSingleRow,
                  "ignore-single-row": _vm.ignoreSingleRow,
                  "train-single-row": _vm.trainSingleRow,
                  "delete-multi-row": _vm.deleteMultiRow,
                  "ignore-multi-row": _vm.ignoreMultiRow,
                  "train-multi-row": _vm.trainMultiRow,
                  stories: _vm.stories,
                },
                on: {
                  isAnyTrained: function ($event) {
                    _vm.isAnyTrained = true
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cb-train-query-list-pagination" },
                [
                  _c("Pagination", {
                    attrs: {
                      "page-change": _vm.pageChange,
                      "page-sizes": _vm.pagination.pageSizes,
                      total: _vm.total,
                      pageSizeLocalStorageKey: "cb-train-page-size",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "side-filter-wrapper" },
          [
            _c("TrainingFilterTool", {
              attrs: { stories: _vm.stories, "row-count": _vm.rows.length },
              model: {
                value: _vm.filters,
                callback: function ($$v) {
                  _vm.filters = $$v
                },
                expression: "filters",
              },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }